/** React Query keys scoped by active company so caches never bleed across company switches. */
export const jobChatsQueryKeys = {
  active: (companyId: string | number | null | undefined) => ["jobChats", "active", companyId] as const,
  history: (companyId: string | number | null | undefined) => ["jobChats", "history", companyId] as const,
  messages: (companyId: string | number | null | undefined, jobEventUid: string | undefined) =>
    ["jobChatMessages", companyId, jobEventUid] as const,
  summary: (companyId: string | number | null | undefined, jobEventUid: string | undefined) =>
    ["jobChats", "summary", companyId, jobEventUid] as const,
};
